import { render } from "./SectionLeaveManagement.vue?vue&type=template&id=4ffe0619&scoped=true"
import script from "./SectionLeaveManagement.vue?vue&type=script&lang=js"
export * from "./SectionLeaveManagement.vue?vue&type=script&lang=js"

import "./SectionLeaveManagement.vue?vue&type=style&index=0&id=4ffe0619&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffe0619"]])

export default __exports__